import React from 'react';
import { Info } from 'lucide-react';

interface ScopeGateBannerProps {
  isToday: boolean;
  isBrokerScope: boolean;
}

/**
 * Shown when the user is viewing today in Platform scope.
 * All write actions (Exit, Cancel, Retry) are restricted to Broker scope
 * because Platform scope shows an incomplete position set (excludes
 * STBT/BTST positions entered on prior dates). The banner explains the
 * restriction and points to the Scope control to resolve it.
 */
const ScopeGateBanner: React.FC<ScopeGateBannerProps> = ({ isToday, isBrokerScope }) => {
  if (!isToday || isBrokerScope) return null;

  return (
    <div className="px-6 py-2 border-b border-blue-100 dark:border-blue-900 bg-blue-50 dark:bg-blue-900/20 text-xs text-blue-800 dark:text-blue-200 flex items-center gap-2">
      <Info className="w-3.5 h-3.5 shrink-0" />
      <span>
        Actions (Exit, Cancel, Retry) are available in{' '}
        <strong className="font-semibold">Broker scope</strong> only — Platform scope
        shows a subset of open positions. Switch using the{' '}
        <strong className="font-semibold">Scope</strong> control above.
      </span>
    </div>
  );
};

export default ScopeGateBanner;
